import { Lightning } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';
import { ScrollList } from '../../components/shared/ScrollList';
import { ScreenSize } from '../../api/ScreenSize';
import { RecordingSection } from './api/RecordingSection';
import { PincodeSection } from './api/PincodeSection';
import { UserSection } from './api/UserSection';
import { StaticPageUrls } from '../../api/analytics/ClientEvents';
import { PlayerSection } from './api/PlayerSection';
import { AutoplaySection } from './api/AutoplaySection';
import { Backend } from '../../api/Backend';
import { SettingsSection } from './api/SettingsSection';
import { ReminderSection } from './api/ReminderSection';

export class SettingsPage extends Lightning.Component {
  private backend: Backend;

  static override _template() {
    return {
      x: 0,
      y: 0,
      w: (w: number) => w,
      h: (h: number) => h,
      color: Theme.Colors.Transparent,
      ItemList: {
        y: 0,
        h: ScreenSize.h,
        w: 750,
        x: 160,
        clipping: true,
        type: ScrollList,
        Items: {
          w: 750,
        },
        signals: {
          onActivate: 'itemActivated',
        },
      },
    };
  }

  override set params(par: { backend: Backend }) {
    this.backend = par.backend;
  }

  override _init() {
    this.backend.logService.trackPageView(StaticPageUrls.settings);
    let sections: SettingsSection[];
    if (this.backend.sessionInfo?.npvr && this.backend.sessionInfo?.npvr.id) {
      sections = [
        new RecordingSection(this.backend),
        new PlayerSection(this.backend),
        new AutoplaySection(this.backend),
        new PincodeSection(this.backend),
        new ReminderSection(this.backend),
        new UserSection(this.backend),
      ];
    } else {
      sections = [
        // new AudioSection(this.backend),
        // new SubtitleSection(this.backend),
        new PlayerSection(this.backend),
        new AutoplaySection(this.backend),
        new PincodeSection(this.backend),
        // new AdultModeSection(this.backend),
        new ReminderSection(this.backend),
        new UserSection(this.backend),
      ];
    }

    this.loadControls(sections);
  }

  private async loadControls(sections: SettingsSection[]) {
    const list = this.tag('ItemList') as ScrollList;
    for (const section of sections) {
      await section.addControls(list);
    }
    list.focusFirstVisible();
  }

  override _handleBack() {
    this.fireAncestors('$focusMenu');
    return true;
  }

  override _getFocused() {
    return this.tag('ItemList');
  }

  itemActivated(item) {
    const action = item.data.action;
    if (action && typeof action === 'function') {
      action(item);
    }
  }
}
